import rootTheme from './themes/rootTheme';
import themeService from './themes/configureThemes';
import sidebar from './themes/sideBar/developersPortal';

themeService.configureThemes(rootTheme, { sidebar });
const theme = themeService.getTheme();

export default theme;
